export const renderDate = (date?: string) => {
	if (date?.includes('T')) {
		return date.split('T')[0].split('-').reverse().join('/');
	}
	return date?.length ? date.split('-').reverse().join('/') : '';
};
